module.exports = __webpack_public_path__ + "static/media/Green_Button_landing@3x.3173b6e6.png";